import axios from 'axios'
import { BASE_API, QUESTIONNAIRE_API } from'../helpers/base'

export function getQuestionnaire(id){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${QUESTIONNAIRE_API}/questionnaire/${id}/questions/monsieur`, {headers});
}

export function postQuestionResponse(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/post_response`, data, {headers});
}

export function getQuestionResponse(id){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${BASE_API}/user/${id}/response`, {headers});
}

export function postOverAllResponse(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/submit_response`, data, {headers});
}

//Services for Talents Questionnaire
export function postResearchQuestionResponse(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/post_research_response`, data, {headers});
}

export function getResearchQuestionResponse(id){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${BASE_API}/user/${id}/research_response`, {headers});
}

export function postResearchRespondDate(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/submit_research_respond_date`, data, {headers});
}

export function getBilanVente(id){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${BASE_API}/get-bilanVente/${id}`, {headers});
}

export function getProductVente(){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${BASE_API}/getProduct/questionnairevente`, {headers});
}



// WEBPACK FOOTER //
// ./src/services/Questionnaire.service.js